import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mint-widget"
}
const _hoisted_2 = { className: "amount-Allowed" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Mint Available:", -1)
const _hoisted_4 = { className: "price" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "Mint price:", -1)
const _hoisted_6 = { className: "controls" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { className: "mint-amount" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { className: "cannot-mint" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "whitelist", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "paused", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.canMint)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.Web3.amountAllowed - Number(_ctx.Web3.alreadyMintedAmount)), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.formattedPrice) + " " + _toDisplayString(_ctx.Web3.networkConfig.symbol), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            className: "decrease",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeAmount(-1))),
            disabled: _ctx.Web3.loading
          }, "-", 8, _hoisted_7),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.mintAmount), 1),
          _createElementVNode("button", {
            className: "increase",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeAmount(1))),
            disabled: _ctx.Web3.loading || _ctx.mintAmount >= _ctx.Web3.amountAllowed - Number(_ctx.Web3.alreadyMintedAmount)
          }, "+", 8, _hoisted_9)
        ]),
        _createElementVNode("button", {
          className: "mintButton",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mint && _ctx.mint(...args))),
          disabled: _ctx.Web3.loading || _ctx.mintAmount == 0
        }, "Mint", 8, _hoisted_10)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_ctx.Web3.isWhitelistMintEnabled && (_ctx.Web3.alreadyMintedAmount == _ctx.Web3.amountAllowed))
            ? (_openBlock(), _createElementBlock("strong", _hoisted_13, "Thanks for Minting!"))
            : (_ctx.Web3.isWhitelistMintEnabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("You are not included in the "),
                  _hoisted_14,
                  _createTextVNode(".")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode("The contract is "),
                  _hoisted_15,
                  _createTextVNode(".")
                ], 64)),
          _hoisted_16,
          _createTextVNode(" Please come back during the next sale! ")
        ])
      ]))
}